import React from 'react'
import { getRGBColor } from '../../helpers';
import './styles.css';

const MAX_NUMBER_OF_HOLDING_PERCENTAGES = 5;

const LargestHoldings = ({ data, largestHoldings }) => {
    const largestHoldingsData = data.filter(item => largestHoldings.includes(item.id)).sort((a, b) => b.holding_pct - a.holding_pct);
    if(largestHoldingsData.length < MAX_NUMBER_OF_HOLDING_PERCENTAGES) {
        const difference = MAX_NUMBER_OF_HOLDING_PERCENTAGES - largestHoldingsData.length;
        for(let i = 0; i < difference; i++) {
            const fillerHoldingsData = {
                popup: '',
                holding_pct: 0,
                color: { r: 0, g: 0, b: 0 }
            }
            largestHoldingsData.push(fillerHoldingsData);
        }
    }

    return (
        <div>
            {/* Title */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px', marginBottom: '16px', fontWeight: 'bold', fontSize: '16px' }}>Top 5 Holdings</div>
            
            {/* Holdings */}
            {largestHoldingsData.map(({ popup: name, holding_pct: holdingPercentage, color }, index) => (
                <div key={index} style={{ marginBottom: '32px', visibility: name === '' ? 'hidden' : 'visible' }}>
                    {/* Information */}
                    <div style={{ display: 'flex', fontSize: '14px', alignItems: 'center' }}>
                        <div style={{ flex: '1 1 0', paddingRight: '8px', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</div>
                        <div className='holding-percentage'>{`${Number(holdingPercentage).toFixed(2)} %`}</div>
                    </div>

                    {/* Progress Bar */}
                    <div style={{ position: 'relative', display: 'flex', height: '10px', marginTop: '8px' }}>
                        {/* Empty Bar */}
                        <div style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: '#efefef' }}></div>

                        {/* Colored Bar */}
                        <div style={{ position: 'absolute', width: `${Number(holdingPercentage).toFixed(2)}%`, height: '100%', backgroundColor: `${getRGBColor(color)}` }}></div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default LargestHoldings